import React from 'react';
import './Cost.scss'
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class Cost extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/Costbanner.png"), imgHDPath: `${require("img/Products/Costbanner.png")} 1x,${require("img/Products/Costbanner@2x.png")} 2x,${require("img/Products/Costbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '清单控制价编制',
          data: '工程量清单与控制价编制是合约造价管控与招标采购工作开展的基础。清单编制无漏项、无错量、清单特征描述准确，可有效减少履约争议；控制价编制准确、可保障招标顺利进行、便于清标与后续价格调整。我们以工厂化、数据化、智能化为主要运作思路，通过协同作业、交付核验，实现清单编制、计价与图形算量同步作业，大幅提高工作精度与速度。',
          imgPath: require("img/Products/costpic1.png"), imgHDPath: `${require("img/Products/costpic1.png")} 1x,${require("img/Products/costpic1@2x.png")} 2x,${require("img/Products/costpic1@3x.png")} 3x`
        },
        {
          title: '工程结算审核',
          data: '对施工承包商申报工程结算书进行审核，合法、合理、准确确定工程结算价款的过程。我们建立了规范化的结算审核流程，强调结算审核不仅要“算的准”，更要“谈的拢”；一方面准确核减申报结算中的不合理价款，最大程度保障委托方利益；另一方面，采取有效措施，高效推进结算审核工作进展，避免久拖不结。',
          imgPath: require("img/Products/costpic2.png"), imgHDPath: `${require("img/Products/costpic2.png")} 1x,${require("img/Products/costpic2@2x.png")} 2x,${require("img/Products/costpic2@3x.png")} 3x`
        },
        {
          title: '全过程造价咨询',
          data: '全过程造价咨询提供目标成本测算、合约规划、设计优化、清单与控制价编制、招标组织管理、清标、商务谈判、重计量、变更洽商审核、设备材料认质认价、结算审核、后评价等全过程咨询服务。我们注重凸显“主控”与“预控”特色，在目标成本确定、合约规划、招采管理等方面采取有效措施，动态管控投资落地。',
          imgPath: require("img/Products/costpic3.png"), imgHDPath: `${require("img/Products/costpic3.png")} 1x,${require("img/Products/costpic3@2x.png")} 2x,${require("img/Products/costpic3@3x.png")} 3x`
        },
        {
          title: '全过程跟踪审计',
          data: '全过程跟踪审计跟踪建设项目全过程，对建设项目从投资立项到竣工交付使用各阶段经济管理活动的真实、合法、效益开展审查、监督、分析和评价。全过程跟踪审计可发挥审计“免疫系统”的作用，一方面督促项目公司严格管理，有效履职；另一方面，发现项目管控中存在的薄弱环节，提出改进意见及建议，保障项目目标的实现。',
          imgPath: require("img/Products/05.png")
        },
      ],
      ascendentLists: [
        {
          title: '首批获得住建部造价咨询甲级资质',
        },
        {
          title: '荣获中价协、京标价协3A和5A信用评价认证、通过IOS9001质量体系认证',
        },
        {
          title: '多次荣获全国造价咨询机构营业收入第一名',
        },
        {
          title: '国家重点工程和知名建设项目服务提供商',
        }
      ],
      caseList: [
        { imgs: require("img/Products/costcase1.png"), name: "国家速滑馆" },
        // { imgs: require("img/Products/costcase2.png"), name: "邯郸环球中心" },
        { imgs: require("img/Products/costcase3.png"), name: "北京新机场" },
        { imgs: require("img/Products/costcase4.png"), name: "兰州地铁" },
        { imgs: require("img/Products/costcase5.png"), name: "海阳核电站" },
        { imgs: require("img/Products/costcase6.png"), name: "国电电力舟山海上风电项目" },

        { imgs: require("img/Products/costcase7.png"), name: "国家某九期信息化建设工程" },
        { imgs: require("img/Products/costcase8.png"), name: "杭州大悦城" },

        { imgs: require("img/Products/costcase9.png"), name: "某企业第8.6代薄膜晶体液晶显示器（TFT-LCD）项目" },

        { imgs: require("img/Products/costcase10.png"), name: "合福高铁" },
        { imgs: require("img/Products/costcase11.png"), name: "中信银行金融后台服务中心" },

      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Cost">
          <h5 className='product-title'>服务优势</h5>
          <Lists dataLists={this.state.ascendentLists}></Lists>
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          <RelatedCases caseList={this.state.caseList} id={'cost'} />
        </div>
      </main>
    )
  }
}
export default Cost
